export default __webpack_public_path__ + "static/elements_and_compounds-8a10c1b4834fa6e44a21c43fb4e1696a.jpg";